module.exports = __webpack_public_path__ + "678862aecbb0ac8a5137e4f283d453fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-25.jpg
// module id = 1166
// module chunks = 0